
import React from 'react';
import { Button } from '../../../components/base/Button';

export const MaterialsSection: React.FC = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="relative">
            <img 
              src="https://readdy.ai/api/search-image?query=High-quality%20insulation%20materials%20display%20showing%20different%20types%20of%20premium%20insulation%20products%2C%20eco-friendly%20materials%2C%20professional%20insulation%20options%2C%20energy%20efficient%20solutions%2C%20clean%20product%20showcase&width=600&height=400&seq=materials&orientation=landscape"
              alt="Premium Insulation Materials"
              className="w-full h-96 object-cover object-top rounded-lg shadow-lg"
            />
          </div>
          
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              Choose Your Insulation Material & Style
            </h2>
            <p className="text-gray-700 leading-relaxed mb-6">
              At Eco Loft Insulation Installers, we cater to your specific needs with an array of <strong>premium insulation materials and solutions</strong>. Whether you prefer traditional mineral wool, modern blown-in insulation, or eco-friendly options, our extensive selection allows us to create a tailored insulation solution that aligns with your energy efficiency goals and budget. Our goal is to combine superior thermal performance with materials that truly reflect your environmental values.
            </p>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center">
                  <i className="ri-check-line text-emerald-600"></i>
                </div>
                <span className="text-gray-700">Mineral Wool Insulation</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center">
                  <i className="ri-check-line text-emerald-600"></i>
                </div>
                <span className="text-gray-700">Blown-in Insulation</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center">
                  <i className="ri-check-line text-emerald-600"></i>
                </div>
                <span className="text-gray-700">Eco-Friendly Options</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center">
                  <i className="ri-check-line text-emerald-600"></i>
                </div>
                <span className="text-gray-700">Premium Performance</span>
              </div>
            </div>
            
            <Button variant="outline" href="/materials">
              View Material Options
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
